<template>
  <span class="gs-transaction-customer">
  <transaction-status-renderer :params="params" />
  <button type="button" class="gs-transaction-name" @click="openDetail"
    v-tooltip="{ content: label, classes: 'gs-transaction-tooltip', html: false, trigger: 'hover focus', delay: { show: 500, hide: 0 } }">
    <span>{{ label }}</span>
    <i v-if="params.data && params.data.assisted_affiliate_id" class="fas fa-random" aria-label="Assisted affiliate"></i>
  </button>
  </span>
</template>
<script>
import TransactionStatusRenderer from './transactionStatusRenderer.vue';
export default {
  components: { TransactionStatusRenderer },
  computed: {
    label() { return String(this.params.value || '') + (Number(this.params.data?.is_test_mode) === 1 ? ' (Test Mode)' : ''); },
  },
  methods: {
    openDetail() { if (this.params.data) this.params.context.componentParent.openTransactionDetail(this.params.data.id); },
  },
};
</script>
